import { prefixerC } from './utils'

export const ROUTE_BANDEJA_PREMISAS = prefixerC('bandeja-premisas')
export const ROUTE_BANDEJA_NIVEL_APROBACION = prefixerC('bandeja-nivel-aprobacion')

export const ROUTE_CREAR_PREMISAS = prefixerC('crear-premisas')
